import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Row, Col, Container, Card } from "reactstrap";
import { environment } from "./baseUrl";
import Modal from 'react-modal';
import { Button } from 'primereact/button';

const BlogComponent = () => {
  const navigate = useNavigate();
  const [ultimasHistorias, setUltimasHistorias] = useState([]);

  const baseUrl = environment.baseUrl + 'historias/';
  const baseImagenUrl = environment.baseUrl + 'imagenes/';
  const [modalOpenIndex, setModalOpenIndex] = useState(null);

  const openModal = (index) => {
    setModalOpenIndex(index);
  };

  const closeModal = () => {
    setModalOpenIndex(null);
  };

  const navigateToDetail = (historiaId) => {
    navigate(`/historia/${historiaId}`);
  };

  const modalStyles = {
    modalContent: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100vw',
      padding: 0,
      margin: 0,
    },
    modalOverlay: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
    },
    modalImageContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
    },
    modalImage: {
      maxWidth: '100%',
      maxHeight: '95%',
    },
    closeButton: {
      position: 'absolute',
      top: '10px',
      right: '10px',
      background: 'transparent',
      cursor: 'pointer',
      fontSize: '16px',
    },
  };

  const peticionGet = async () => {
    try {
      const response = await axios.get(baseUrl + 'ultimas');
      setUltimasHistorias(response.data);
    } catch (error) {
      console.error("Error al obtener las últimas historias:", error.response || error);
    }
  };

  useEffect(() => {
    peticionGet();
  }, []);

  return (
    <div>
      <div className="blog-home2 spacer">
        <Container>
          <Row className="justify-content-center">
            <Col md="8" className="text-center">
              <h2 className="title">Nuevas publicaciones</h2>
              <h6 className="subtitle">
                Revisa la programación historica, comparte la experiencia con las mejores historias de la Corte Superior de Justicia de La Libertad.
              </h6>
            </Col>
          </Row>
          <Row className="m-t-40 justify-content-center">
            {ultimasHistorias.map((historia, index) => (
              <Col lg="4" md="6" key={historia.id}>
                <Card>
                  <img
                    className="card-img-top"
                    src={baseImagenUrl + historia.urlImagen}
                    alt="Historia Imagen"
                    onClick={() => openModal(index)}
                    onError={(e) => {
                      e.target.src = "/logos/pjrojo.png";
                      e.target.style.transform = "scale(0.6)";
                      e.target.style.objectFit = "contain";
                    }}
                    style={{ cursor: 'pointer' }}
                  />
                  <h5 className="font-medium m-t-30"> <a className="link">{historia.titulo} </a> </h5>
                  <a
                    onClick={() => navigateToDetail(historia.id)}
                    className="linking text-themecolor m-t-10"
                    style={{ cursor: 'pointer' }}
                  >
                    Ver más <i className="ti-arrow-right"></i>
                  </a>
                </Card>
                <Modal
                  isOpen={modalOpenIndex === index}
                  onRequestClose={closeModal}
                  contentLabel="Imagen Maximizada"
                  style={{ content: modalStyles.modalContent, overlay: modalStyles.modalOverlay }}
                >
                  <Button onClick={closeModal} style={modalStyles.closeButton} icon="pi pi-times" className="p-button-rounded p-button-outlined p-button-danger mr-2" />
                  <div style={modalStyles.modalImageContainer}>
                    <img
                      src={baseImagenUrl + historia.urlImagen}
                      alt={historia.titulo}
                      style={modalStyles.modalImage}
                    />
                  </div>
                </Modal>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default BlogComponent;